import { render, staticRenderFns } from "./dragDialog.vue?vue&type=template&id=61c7bfc0"
import script from "./dragDialog.vue?vue&type=script&lang=js"
export * from "./dragDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports